export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Industrial%20geomembrane%20welding%20machine%20on%20a%20large%20construction%20site%20with%20black%20HDPE%20liner%20and%20professional%20worker%20operating%20equipment%2C%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20industrial%20aesthetic%2C%20heavy%20machinery%20texture%2C%20professional%20engineering%20environment%2C%20sharp%20focus%20on%20welding%20seam%2C%20warm%20orange%20glow%20from%20hot%20wedge%2C%20deep%20shadows&width=1800&height=900&seq=geomembrana-hero-01&orientation=landscape"
        alt="Máquinas de solda de geomembrana em operação em obra industrial"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      <div className="absolute inset-0 bg-black/20" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center py-16">
        <span className="inline-block text-green-400 text-xs md:text-sm font-black uppercase tracking-[0.25em] mb-4 border border-green-500/30 rounded-full px-4 py-1.5 bg-green-500/10">
          SoldaGeo Brasil
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white uppercase leading-tight mb-6 tracking-tight">
          Máquinas de Solda de Geomembrana
        </h1>
        <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
          A SoldaGeo oferece máquinas e equipamentos para soldagem de geomembranas e termoplásticos, com diferentes modelos para aplicações profissionais em impermeabilização, saneamento, mineração, aquicultura, reservatórios e outras obras.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="#maquinas"
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-black text-sm px-6 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-arrow-down-line" />
            Ver Máquinas
          </a>
          <a
            href="#ajuda"
            className="flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-black text-sm px-6 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-customer-service-2-line" />
            Falar com Especialista
          </a>
        </div>
      </div>
    </section>
  );
}